import React from 'react';
import CardBase from './CardBase';
import PriceBubble from './PriceBubble';

interface WaterCardProps {
    type: 'still' | 'sparkling';
    onClick: () => void;
    isSelected: boolean;
    selectedStyle: string;
}

const WaterCard: React.FC<WaterCardProps> = ({ type, onClick, isSelected, selectedStyle }) => {
    const isStill = type === 'still';
    const volumeTextClass = `w-72 h-20 ${isStill ? 'left-[8px]' : 'left-[12px]'} top-[215px] absolute text-center text-white text-4xl font-extrabold font-['Montserrat'] leading-none`;
    return (
        <CardBase onClick={onClick} isSelected={isSelected} selectedStyle={selectedStyle} isWater={true}>
            <div data-layer={type} className={`h-14 ${isStill ? 'left-[79px] w-40 uppercase' : 'left-0 w-80 uppercase'} top-[90px] absolute z-50 text-center text-teal-500 text-[40px] font-extrabold font-['Montserrat'] leading-[48px]`}>
                {type}
            </div>
            <div className={volumeTextClass}>50cl 500mL<br />or 0,5L</div>
            <PriceBubble price="FREE" isStill={isStill} />
            {!isStill && (
                <>
                    <img className="w-[150px] h-[100px] left-[152px] top-[10px] absolute origin-top-left opacity-36" src="/assets/images/new_design/drink_selection/bulles-fontaine-8.svg" alt="bubble" />
                    <img className="w-[150px] h-[100px] left-[20px] top-[73px] absolute origin-top-left opacity-36" src="/assets/images/new_design/drink_selection/bulles-fontaine-9.svg" alt="bubble" />
                </>
            )}
        </CardBase>
    );
};

export default WaterCard;
